import { useContext } from "react";
import CatResultContext from "./context";

const useCatResult = () => {
    return useContext(CatResultContext);
};

export default useCatResult;
